// Mobile-only back bar for pages without a contextual mobile header
// (contact, profile, indicators catalog). Goal/target/indicator screens
// use their own "Back to Goals / Targets / Indicators" controls.
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { ArrowBack } from '@mui/icons-material';

const HOME_PATHS = ['/', '/un-sdg', '/eu-sdg'];

function isGoalFlowPath(pathname) {
  return /^\/(un-sdg|eu-sdg)\/goal\//.test(pathname || '');
}

const DetailBackBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const path = (location.pathname || '/').replace(/\/+$/, '') || '/';
  const isHome = HOME_PATHS.includes(path);
  const showBack = isMobile && !isHome && !isGoalFlowPath(path);

  if (!showBack) return null;

  return (
    <div className="mobile-header detail-back-bar">
      <button
        type="button"
        className="mobile-back-btn"
        onClick={() => navigate(-1)}
        aria-label="Go back"
      >
        <ArrowBack fontSize="small" /> Back
      </button>
    </div>
  );
};

export default DetailBackBar;
